module.exports = __webpack_public_path__ + "static/media/0010.e729cf35.jpg";